<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebサイトはサイトマップファイルを持っています。
        </p>
        <p v-else>
          あなたのWebサイトはサイトマップファイルを持っていません。
        </p>
      </div>
    </li>
    <li v-if="hasSiteMapPaths.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <ul class="c-list--disc">
          <li v-for="(item, index) in hasSiteMapPaths" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p v-if="hasSiteMapPaths.length">
          サイトマップ内に調査したURLが存在していないため、追記してください。
        </p>
        <p v-else>
          sitemap.xmlを設置してください。<br />※ドメインルート直下のsitemap.xmlへアクセスした際、転送設定されていても判定として問題はありません。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    hasSiteMapPaths() {
      if (this.detail.paths) {
        return this.detail.paths.filter(item => item);
      }
      return [];
    }
  }
};
</script>
